import type { components } from "@dolfin/api-public";

type LedgerAccount = components["schemas"]["LedgerAccountResponse"];

export function isIncome(account: LedgerAccount) {
  const words = `${account.classification ?? ""} ${account.accountType ?? ""}`.toLowerCase();
  return words.includes("revenue") || words.includes("income") || words.includes("sales");
}

export function isExpense(account: LedgerAccount) {
  const words = `${account.classification ?? ""} ${account.accountType ?? ""}`.toLowerCase();
  return words.includes("expense") || words.includes("cost") || words.includes("overhead");
}

// Stable: the matches first, each group in its original order.
export function sortBy<T>(items: T[], first: (item: T) => boolean) {
  return [...items.filter(first), ...items.filter((i) => !first(i))];
}
